import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '@lib/context/AuthContextType';

interface PortalRouteProps {
  children: React.ReactNode;
  role?: 'employee' | 'client';
}

export const PortalRoute = ({ children, role }: PortalRouteProps) => {
  const { isAuthenticated, user, loading } = useContext(AuthContext)!;

  if (loading) return (
    <div className="min-h-screen bg-[#FAF6F0] flex items-center justify-center">
      <span className="material-symbols-outlined animate-spin text-[#C77D3F] text-4xl">progress_activity</span>
    </div>
  );

  if (!isAuthenticated) return <Navigate to="/portal/login" replace />;

  // Admin/owner/pm landed on portal — redirect to main dashboard
  if (user?.role && ['admin', 'owner', 'pm', 'user', 'crew'].includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (role && user?.role !== role) {
    const dest = user?.role === 'employee' ? '/portal/employee' : '/portal/client';
    return <Navigate to={dest} replace />;
  }

  return <>{children}</>;
};
